module.exports = __webpack_public_path__ + "static/media/subICloud3.1115b6a2.png";